(function ($) {

	'use strict';
	/* globals jQuery */

	var defaults = {
		selectors: {
			gridLayout: '>.gridlayout',
			gridPanels: '>.modGridLayout>.column',
			prevButton: '.carousel-prev',
			nextButton: '.carousel-next',
			pagerItems: '.carousel-control > a',
			clip: '.carousel-clip',
			list: 'ul.carousel-list',
			listItems: ''								// optional, by default the direct children of the list are taken
		},
		pagerItemsActiveCls: 'selected',
		noItemsCls: 'noScrolling',
		disabledButtonCls: 'disabled',
		slideGridRows: true,
		animation: {
			duration: 'normal',
			easing: 'swing'
		}
	};

	/**
	 * Dynamic opacity gradient against background
	 *
	 * draw an opacity gradient to the foreground that will
	 * look like the actual content gets faded out against
	 * the actual background. Currently only images and solid
	 * colors are implemented (solid color can alternatively
	 * be handled in pure css, if you never have bg images).
	 *
	 * @author Marcel Greter
	 * @namespace local
	 * @class OpacityGradient
	 */
	function OpacityGradient(el, ct, conf) {

		/* jshint maxstatements: 40 */
		this.canvas = $('<canvas>');
		this.context = this.canvas[0].getContext('2d');

		// canvas not supported?
		if (!this.context) { return; }

		this.el = $(el);

		this.config = $.extend({}, {
			// selectors return in document order and we use the last one!
			pageBgSelector: '.full-height-background, .scs-stage-flat, BODY',
			gridColSelector: '>ul.carousel-list>:first>.gridlayout>.modGridLayout>.column'
		}, conf);

		this.el.css({
			position: 'relative'
		});

		// get parent node for outer content area
		this.ct = ct;
		var width = this.ct.width() - this.el.width();
		var height = this.el.outerHeight() * 5;

		this.canvas[0].width = width;
		this.canvas[0].height = height;

		// currently the fade-out is always right aligned and size tells us how wide it will be
		// query cols of the first grid layout to determine the size (if not explicitly given)
		this.size = this.config.size || (1 / $(this.config.gridColSelector, this.el).length);

		// get one element that has a background defined
		var bgEl = $(this.config.pageBgSelector),
		    bgUrl = $(bgEl.last()).css('background-image'),
		    bgCol = $(bgEl.last()).css('background-color');
		this.bgImg = $(bgEl.last()).find('>IMG');
		// we do not support stage areas areas with streched background
		if ($('>.scs-stage-flat-inner>IMG', bgEl.last()).length) { return; }

		// try to extract the src url for the background-image
		var urlMatch = /^\s*url\(([\'\"]?)(.*?)\1\)/.exec(bgUrl);
		if (urlMatch && urlMatch.length > 1) { bgUrl = urlMatch[2]; }
		// handle findings and attach to object
		if (bgUrl == 'none') { bgUrl = null; }
		if (bgCol) { this.color = bgCol; }
		if (bgUrl || this.bgImg.length) { this.image = new Image(); }
		if (this.image) { this.image.src = bgUrl || this.bgImg.attr('src'); }

		// add canvas element to the dom
		this.wrapper = $('<div>');
		this.wrapper.css({
			top: 0,
			bottom: 0,
			right: 0,
			width: width,
			overflow: 'hidden',
			position: 'absolute',
			'pointer-events': 'none'
		});
		this.wrapper.append(this.canvas);

		// will wait for image to be loaded
		var renderer = $.proxy(this.render, this);

		if (this.image) {
			// wait for bg-image to be loaded
			if (this.image.complete) { renderer(); }
			else { this.image.onload = renderer; }
		} else if (this.color) {
			// render color right away
			renderer();
		}

		// hook into window resize event
		$(window).resize(renderer);

		this.el.append(this.wrapper);

	}

	// declare class methods
	(function (proto) {

		// main render function
		// image must already be loaded
		proto.render = function render() {

			var width = this.ct.width() - this.el.width();
			var height = this.el.outerHeight() * 5;

			var canvas = this.canvas[0];
			var context = this.context;
			var offPos = this.el.offset();
			if (this.bgImg.length) {
				var imgOff = this.bgImg.offset();
				offPos.top -= imgOff.top;
				offPos.left -= imgOff.left;
			}
			offPos.top = Math.round(offPos.top);
			offPos.left = Math.round(offPos.left);

			context.clearRect (0, 0, canvas.width, canvas.height);

			this.canvas[0].width = width;
			this.canvas[0].height = height;
			this.wrapper.css({ 'width': width });
			offPos.left += this.ct.width() - this.canvas[0].width;

			/*
			// implementation for partial bg height
			var bg_height = $('.scs-stage-flat').height();
			if (bg_height) {
				var w = canvas.width;
				var h = canvas.height;
				h = Math.min(h, bg_height - offPos.top);
				context.beginPath();
				context.moveTo(0,0);
				context.lineTo(w, 0);
				context.lineTo(w, h);
				context.lineTo(0, h);
				context.clip();
			}
			*/

			context.translate(- offPos.left, - offPos.top);

			if (this.image) {
				context.fillStyle = context.createPattern(this.image, 'repeat');
			} else {
				context.fillStyle = this.color;
			}

			context.globalCompositeOperation = 'source-over';
			context.fillRect(0, 0, canvas.width + offPos.left, canvas.height + offPos.top);
			context.translate(offPos.left, offPos.top);

			var gradient = context.createLinearGradient(0, 0, canvas.width, 0);
			gradient.addColorStop(0.0, 'rgba(255, 255, 255, 0.0)');
			gradient.addColorStop(1.0, 'rgba(255, 255, 255, 1.0)');
			context.fillStyle = gradient;
			context.globalCompositeOperation = 'destination-in';
			context.fillRect(0, 0, canvas.width, canvas.height);

		};

	})(OpacityGradient.prototype);

	$.scCarousel = function (e, o) {

		/* jshint maxstatements: 70 */
		var me = this; // local scope inside cascaded functions


		this.options = $.extend({}, defaults, o || {});
		this.container = $(e);

		this.clip = this.container.find(this.options.selectors.clip);
		this.list = this.clip.find(this.options.selectors.list);
		this.listItems = (this.options.selectors.listItems && this.options.selectors.listItems.length) ? this.list.find(this.options.selectors.listItems) : this.list.children();

		this.carouselOverflow = false;
		this.options.firstSlide = this.container.data('first-slide');
		this.options.infiniteLoop = this.container.data('infinite-loop');
		this.options.slideGridRows = this.container.hasClass('slide-grid-panels');
		this.options.fadeOutGridPanel = this.container.hasClass('shadow-last-grid-panel');

		// first slide start from one
		if (isNaN(this.options.firstSlide)) {
			this.options.firstSlide = 1;
		}

		// options are mutually exclusive
		if (this.options.slideGridRows) {
			this.options.infiniteLoop = false;
			// Fix only needed as long as css styles forces fixed widths
			jQuery('.contentWide .carouselContainer').css({ width: 'auto' });
			jQuery('.contentWide .carouselContainer LI.large').css({ width: 'auto' });
		}

		this.gridMargin = 0;
		if (this.options.slideGridRows) {
			// adjust overflow for possible shadows
			this.clip.css({ 'margin': -8, 'padding': 8 });
			this.listItems.css({ 'margin': -8, 'padding': 8 });
			// var rows = $('>.gridlayout>.single-row', this.listItems);
			var rows = $('>.gridlayout>.modGridLayout', this.listItems);
			this.gridMargin = parseInt(rows.css('margin-left'), 10) * -1;
			this.listItems.not(':last').css('margin-right', this.gridMargin - 8);
			// add class to mark the 'row' for synced heights
			this.container.addClass('row');
		}

		// get navigation-buttons and paging-navigation
		this.prevButton = this.container.find(this.options.selectors.prevButton);
		this.nextButton = this.container.find(this.options.selectors.nextButton);
		this.pagingItems = this.container.find(this.options.selectors.pagerItems);

		// definitions
		this.position = 0;
		this.isAnimating = false;

		var gridFirstLayout = $(this.options.selectors.gridLayout, this.listItems[0]);
		var gridFirstPanels = $(this.options.selectors.gridPanels, gridFirstLayout);
		var gridLastLayout = $(this.options.selectors.gridLayout, this.listItems[this.listItems.length - 1]);
		var gridLastPanels = $(this.options.selectors.gridPanels, gridLastLayout);

		var overflow = 1;
		this.stepSize = 1;
		this.lastPanelMissing = 0;
		if (this.options.slideGridRows) {
			this.gridSize = gridFirstPanels.length;
			if (gridFirstPanels.length > 0) {
				this.stepSize /= this.gridSize;
				overflow += this.stepSize;
			}
			this.lastPanelMissing = 1 - this.stepSize * gridLastPanels.length;
			this.gridLayouts = $(this.options.selectors.gridLayout, this.listItems);
			this.gridPanels = $(this.options.selectors.gridPanels, this.gridLayouts);
		} else {
			this.gridSize = 1;
		}
		if (this.options.fadeOutGridPanel) {
			this.ct = this.clip.closest('.content, .gridlayout');
			this.overflowWidth = this.ct.width() - this.clip.width();
			this.container.find('>.carousel-clip').css({
				'padding-right': this.overflowWidth,
				'margin-right': - this.overflowWidth

			});
		}

		this.updateNavigationWidth();
		if (!isNaN(this.options.firstSlide)) {
			this.setPosition((this.options.firstSlide - 1) * this.gridSize);
		}
		this.updateNavigationStates();

		// bind events to the navigation buttons
		this.prevButton.on('click', function (e) {
			me.slideTo(me.position * me.gridSize - 1);
			e.preventDefault();
		});
		this.nextButton.on('click', function (e) {
			me.slideTo(me.position * me.gridSize + 1);
			e.preventDefault();
		});

		// bind events to the pagination
		this.pagingItems.each(function (i) {
			$(this).data('carousel-paging-index', i);
		});
		this.pagingItems.on('click', function (e) {
			me.slideTo($(this).data('carousel-paging-index'));
			e.preventDefault();
		});

		// bind keyboard events
		this.container.on('keyup', function (e) {
			if (e.which == 37) { // left
				e.preventDefault();
				me.slideTo(me.position * me.gridSize - 1);
			} else if (e.which == 39) { // right
				e.preventDefault();
				me.slideTo(me.position * me.gridSize + 1);
			}
		});

		// enable touch-events if availlable
		if (!!('ontouchend' in document)) { this.enableTouch(); }

		if (this.options.fadeOutGridPanel) {
			var self = this;
			this.clip.each(function (i, el) {
				var grad = new OpacityGradient(el, self.ct);
				if (self.container.hasClass('clickable-gradient')) {
					grad.wrapper.css({
						'cursor': 'pointer',
						'pointer-events': ''
					});
					grad.canvas.on('click', function (/* e */) {
						self.nextButton.click();
					});
				}
			});
		}

		if (this.options.slideGridRows) {
			this.listItems.addClass('active-item');
			for (var i = 0, L = i + this.gridSize; i < L; i += 1) {
				$(this.gridPanels[i]).addClass('active-item');
			}
		} else {
			this.listItems.first().addClass('active-item');
		}

		this.fireEvent('onAfterInit');
	};

	$.extend($.scCarousel.prototype, {

		fireEvent: function () {
			// convert arguments-object (is not a real array) into an array
			var params = [];
			for (var i=0; i < arguments.length; i+=1) {
				params.push(arguments[i]);
			}

			var event = params.shift();
			if (typeof this.options[event] == 'function') {
				params.unshift(this);
				this.options[event].apply(this.container[0], params);
			}
		},

		updateNavigationWidth: function(){
			// initial DOM manipulations
			this.list.css('width', ''); // When in accordion and not visible, the list width is truncated
			this.listItemWidth = Math.max(this.clip.width(), this.listItems.eq(0).outerWidth(true));
			this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
			if (this.listItems.length <= 1) {
				this.container.addClass(this.options.noItemsCls);
			}
		},

		updateNavigationStates: function () {
			if (!this.options.infiniteLoop) {
				this.prevButton[this.position > 0 ? 'removeClass' : 'addClass'](this.options.disabledButtonCls);
				this.nextButton[this.position >= this.listItems.length-1 - this.lastPanelMissing ? 'addClass' : 'removeClass'](this.options.disabledButtonCls);
			}
			var position = this.position;
			// this should only be needed for endless carousel mode
			if (position == -1) { position = this.listItems.length - 1; }

			this.pagingItems.filter('.' + this.options.pagerItemsActiveCls).blur();
			this.pagingItems
				.removeClass(this.options.pagerItemsActiveCls)
				.filter(':eq(' + position + ')').addClass(this.options.pagerItemsActiveCls);
		},

		normalizePosition: function (pos) {
			if (this.options.infiniteLoop) {
				var L = this.listItems.length - 1;
				while (pos > L) { pos -= L + 1; }
				while (pos < 0) { pos += L + 1; }
			}
			return pos;
		},

		slideTo: function (newPos) {
			/* jshint maxstatements: 40 */
			if (this.isAnimating) {
				return;
			}
			if (!this.options.infiniteLoop) {
				newPos /= this.gridSize;
				newPos = newPos < 0 ? 0 : (newPos >= this.listItems.length-1 - this.lastPanelMissing ? this.listItems.length-1 - this.lastPanelMissing : newPos);
			}
			// moving carousel outside on the left
			// ensure to add last panel before first
			else if (newPos < 0) {
				var panels = this.listItems,
				    rPanel = $(panels[panels.length-1]);
				rPanel.insertBefore(panels[0]);
				rPanel.css('margin-left', - this.listItemWidth);
			}
			var me = this; // local scope inside cascaded functions
			this.isAnimating = true;
			var oldPos = this.position;
			var futurePos = newPos;
			var activePos = this.position;
			if (!this.options.infiniteLoop) {
				if (parseInt(newPos, 10) != newPos) {
					if (newPos > oldPos) {
						futurePos = Math.ceil(futurePos);
						activePos = Math.floor(activePos);
					} else {
						futurePos = Math.floor(futurePos);
						activePos = Math.ceil(activePos);
					}
				}
			}

			var futureItem = this.listItems.eq(me.normalizePosition(futurePos));
			var activeItem = this.listItems.eq(me.normalizePosition(activePos));

			this.fireEvent('onBeforeAnimation', activeItem[0], futureItem[0], newPos, this.position, this.listItems.length);
			me.prepareAnimation(newPos);

			if (this.options.slideGridRows) {
				this.gridPanels.removeClass('active-item');
				var gridPanelFirstIndex = this.position * this.gridSize;
				for (var i = gridPanelFirstIndex, L = i + this.gridSize; i < L; i += 1) {
					$(this.gridPanels[i]).addClass('active-item');
				}
			} else {
				this.listItems.removeClass('active-item');
				futureItem.addClass('active-item');
			}
			this.updateNavigationStates();
			if (typeof futureItem.position() !== 'undefined') {
				var futureRight = this.position * this.listItemWidth;

				this.list.animate({'right': futureRight + 'px'}, this.options.animation.duration, this.options.animation.easing, function () {
					me.isAnimating = false;
					me.position *= me.gridSize;
					me.fireEvent('onAfterAnimation', activeItem[0], futureItem[0], me.position, oldPos, me.listItems.length);
					me.position /= me.gridSize;
					me.setPosition(me.position);
				});
			}
		},

		prepareSlideCarousel: function (pos) {
			var delta = pos - this.position;
			if (!this.options.infiniteLoop) {
				pos = Math.max(0, Math.min(this.listItems.length - 1, pos));
			} else {
				// bring into valid range
				var L = this.listItems.length;
				while (pos < -1) { pos += L; }
				while (pos > L - 1) { pos -= L; }
				var panels, rPanel;
				// position is moving into left abiss?
				if (pos < 0 || (pos === 0 && delta > 0)) {
					if (!this.carouselOverflow) {
						panels = this.listItems;
						rPanel = $(panels[panels.length-1]);
						rPanel.insertBefore(panels[0]);
						rPanel.css('margin-left', - this.listItemWidth);
						this.carouselOverflow = true;
					}
				} else {
					if (this.carouselOverflow) {
						panels = this.listItems;
						rPanel = $(panels[panels.length-1]);
						rPanel.insertAfter(panels[panels.length-2]);
						rPanel.css('margin-left', '');
						this.carouselOverflow = false;
					}
				}
			}
			return pos;
		},

		prepareAnimation: function (pos) {
			var delta = pos - this.position;
			pos = this.prepareSlideCarousel(pos);
			var off = (pos - delta) * this.listItemWidth;
			this.list.css('right', off + 'px');
			this.position = pos;
		},

		setPosition: function (pos) {
			pos = this.prepareSlideCarousel(pos);
			var off = pos * this.listItemWidth;
			this.list.css('right', off + 'px');
			this.position = pos;
		},

		enableTouch: function () {
			var me = this,
				dragEl = this.list,
				dragStarted = false,
				dragStartFingerPos, dragStartElementPos, dragMaxPos, dragMinPos, lastFingerPos, lastDirection;
			dragEl.on('touchstart', function (e) {
				if (dragStarted) { return true; }
				me.list.stop(true);
				me.isAnimating = false;
				dragStartFingerPos = event.touches && event.touches.length ? event.touches[0].pageX : e.originalEvent.pageX;
				var rightPos = dragEl.css('right').replace('px', '');
				if (isNaN(rightPos)) { rightPos = 0; } // maybe it's not yet set
				dragStartElementPos = isNaN(rightPos-0) ? 0 : rightPos;
				dragMinPos = 0;
				dragMaxPos = me.listItemWidth * (me.listItems.length - 1);
				dragStarted = true;
			}).on('touchmove', function (e) {
				if (!dragStarted) { return true; }
				//e.preventDefault(); // prevent scrolling
				var fingerPos = event.touches && event.touches.length ? event.touches[0].pageX : e.originalEvent.pageX;
				var delta = fingerPos - dragStartFingerPos;
				lastDirection = fingerPos > lastFingerPos ? 'right' : 'left';
				lastFingerPos = fingerPos;
				var off = dragStartElementPos - delta;
				me.setPosition(off / me.listItemWidth);
			}).on('touchend', function (/* e */) {
				if (!dragStarted) { return true; }
				var pos = dragEl.css('right').replace('px', '');
				if (isNaN(pos)) { pos = 0; } // maybe it's not yet set
				var visibleItem = me.listItems.length - (((me.listItemWidth * (me.listItems.length - 1)) - pos) / me.listItemWidth) - 1;
				var proximity = visibleItem % 1;
				var nextItem;
				if (proximity <= 0.2 || proximity >= 0.8) { nextItem = Math.round(visibleItem); }
				else { nextItem = parseInt(visibleItem, 10) + (lastDirection == 'right' ? 0 : 1); }
				me.slideTo(nextItem);
				dragStarted = false;
			});
		},

		showNext: function (wrapAround) {
			var newPos = this.position + this.stepSize;
			if (wrapAround) {
				if (newPos > this.listItems.length -1 ) { newPos = 0; }
			}
			this.slideTo(newPos);
		}

	});

	$.fn.scCarousel = function (o) {
		var $this = $(this);
		if ($this.length == 1 && $this.data('scCarousel')) {
			return $this.data('scCarousel');
		} else {
			return this.each(function () {
				var $this = $(this);
				if (!$this.data('scCarousel')) {
					$this.data('scCarousel', new $.scCarousel(this, o));
				}
			});
		}
	};

})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/scCarousel.js
// module id = 113
// module chunks = 0